<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'AllDicts' }" id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к справочникам
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование справочника глобальных настроек:</h3>

							<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn">
								<div class="md-layout">
									<div class="md-layout-item md-size-100 md-xsmall-size-100 savebtn text-right">
										<router-link :to="{ name: 'configItemData', params: {id: 'new', dictCode: dictId, page: filterData.page}}"
													 class="md-primary"
													 tag="md-button">
											Добавить новый элемент
										</router-link>
									</div>
								</div>
								<md-card v-if="configListData.length>0" class="md-card-plain">
									<md-card-content>
										<md-table class="table-shopping" v-model="configListData">
											<md-table-row slot="md-table-row" slot-scope="{ item }">
												<md-table-cell md-label="Код элемента">
													<router-link
															:to="{ name: 'configItemData', params: { id: item.paramCode } }">
														{{ item.paramCode }}
													</router-link>
												</md-table-cell>
												<md-table-cell md-label="Значение">
													<router-link
															:to="{ name: 'configItemData', params: { id: item.paramCode } }">
														{{ item.paramValue }}
													</router-link>
												</md-table-cell>
												<md-table-cell>
													<router-link
															:to="{ name: 'configItemData', params: { data: item, action: 'delete'} }"
															event="" @click.native.prevent="confirmDelete({ name: 'configItemData', params: { data: item, action: 'delete'} })"
													>
														<md-icon>delete</md-icon>
													</router-link>
												</md-table-cell>
											</md-table-row>
										</md-table>
									</md-card-content>
								</md-card>
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>

	</div>
</template>
<script>
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import { getItem } from '@/utils/dict-api'

    export default {
        props: ['configId', 'page'],
        bodyClass: 'model-list',
        data () {
            return {
                options: [],
                dictId: this.$route.params.dictCode,
                configListData: [],
                pagination: {
                    currentPage: 1,
                    total: 1,
                    fromRec: 0,
                    toRec: 0,
                    totalRec: 0,
                },
                filterData: {
                    page: this.page || 1,
                },
            }
        },
        methods: {
            getData () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('global').then(result => {
                        this.configListData = result
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
			confirmDelete (route) {
				if (confirm("Действительно удалить?")) {
					this.$router.push(route);
				}
			}
        },
        created () {
            this.getData()
        },
    }
</script>
<style lang="scss" scoped type="text/scss">
	.savebtn {
		margin-right: 0;
		padding-right: 5px;
	}

</style>
